import script from "./trademark.vue?vue&type=script&setup=true&lang=ts"
export * from "./trademark.vue?vue&type=script&setup=true&lang=ts"

import "./trademark.vue?vue&type=style&index=0&id=9e14a080&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e14a080"]])

export default __exports__